import React from "react";
import CardSlide from "../Slider/card_slide";
import banner from "../../../assets/images/fitbae/banner.png";
import banner2 from "../../../assets/images/fitbae/banner2.png";

const Banner = () => {
  return (
    <>
      <div>
        <div className="carousel w-full mb-5 hidden">
          <div id="slide1" className="carousel-item relative w-full">
            <img src={banner} className="w-full" />
            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#slide4" className="">
                ❮
              </a>
              <a href="#slide2" className="">
                ❯
              </a>
            </div>
          </div>
          <div id="slide2" className="carousel-item relative w-full">
            <img src={banner2} className="w-full" />
            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#slide1" className="">
                ❮
              </a>
              <a href="#slide3" className="">
                ❯
              </a>
            </div>
          </div>
          <div id="slide3" className="carousel-item relative w-full">
            <img src={banner} className="w-full" />
            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#slide2" className="">
                ❮
              </a>
              <a href="#slide4" className="">
                ❯
              </a>
            </div>
          </div>
          <div id="slide4" className="carousel-item relative w-full">
            <img src={banner2} className="w-full" />
            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
              <a href="#slide3" className="">
                ❮
              </a>
              <a href="#slide1" className="">
                ❯
              </a>
            </div>
          </div>
        </div>
      </div>
      <img
        src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFB_WebBanner_Mobile_900x1320_20230628V001.png?alt=media&token=b5d33220-9a27-42e3-b197-dd7a3c64ec28"
        alt=""
        className="w-full max-h-[85vh] object-cover object-center block md:hidden"
      />
      {/* <div className="w-full h:auto md:hidden">
        <img src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFB_WebBanner_Mobile_400x800_20230628V001.jpg?alt=media&token=9d659dad-b14f-4314-a0ee-45dfd5c5d667" className=" md:h-auto object-cover "  alt="" />
      </div> */}
      {/* <div className="w-full md:h-auto hidden md:block"> */}
      <img
        src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FFB_WebBanner_Desktop_20230628V001.jpg?alt=media&token=11f6f258-6cad-4e53-8a97-a806b140a15b"
        className="w-full h-auto object-contain hidden md:block"
        alt=""
      />
      {/* </div> */}
      {/* <div className="">
        <HeroSlider
          height={"100vh"}
          autoplay
          controller={{
            initialSlide: 1,
            slidingDuration: 500,
            slidingDelay: 100,
            onSliding: (nextSlide) =>
              console.debug("onSliding(nextSlide): ", nextSlide),
            onBeforeSliding: (previousSlide, nextSlide) =>
              console.debug(
                "onBeforeSliding(previousSlide, nextSlide): ",
                previousSlide,
                nextSlide
              ),
            onAfterSliding: (nextSlide) =>
              console.debug("onAfterSliding(nextSlide): ", nextSlide),
          }}>
          <Overlay>
            <div className="flex h-screen justify-center items-center">
              <div className=" mt-52 ">
                <button className="px-4 py-2 bg-yellow-500 font-bold rounded-xl hover:scale-105 transition-all">
                  SHOP ALL STYLE
                </button>
              </div>
            </div>
          </Overlay>
          <Slide
            background={{
              backgroundImageSrc: imageCodes.img2.image,
              backgroundAttachment: "fixed",
              backgroundSize: "contain ",
              backgroundRepeat: "no-repeat",
              backfaceVisibility: "hidden",
            }}
          />
          <Slide
            background={{
              backgroundImageSrc: imageCodes.img1.image,
              backgroundImageSizes:'cover'
            }}
          />
          <Slide
            background={{
              backgroundImageSrc: imageCodes.img3.image,
              backgroundAttachment: "fixed",
              backgroundSize: "contain ",
              backgroundRepeat: "no-repeat",
              backfaceVisibility: "hidden",
            }}
          />
          <Slide
            background={{
              backgroundImageSrc: imageCodes.img5.image,
              backgroundAttachment: "fixed",
              backgroundSize: "contain ",
              backgroundRepeat: "no-repeat",
              backfaceVisibility: "hidden",
            }}
          />{" "}
          <div className="">
            <Nav />
          </div>
        </HeroSlider>
      </div> */}
    </>
  );
};

export default Banner;
